<template>  
  <div class="bstore">
	<el-select :size="slsize" clearable style="width: 100%;" v-model="slvl" filterable :placeholder="$t('app_select')" @change="onChange">
		<el-option
		  v-for="(item,index) in tableData"
		  :key="item.branchNo"
		  :label="item.branchName"
		  :value="item.branchNo"> <!-- branchNo -->
		</el-option>
	</el-select>
  </div>
</template>

<script>
export default {  
  data () {
    return { 
      tableData: [],
      slvl: '',
      slsize: '',
	  mcid: ''
    }
  },
  // value size两个值，callback回调选择的值
  props: ['config'],
  watch: {
    config (n) {
	    this.mcid = n.mcid?n.mcid:''
      this.slsize = n.size?n.size:''
      this.slvl = n.value?parseInt(n.value):''	  
	    this.getList()	
    }
  },
  methods: {
    setDfVl (vl) {
      this.slvl = vl
      this.onChange(vl)
    },
    onChange (vl) {      
      if (this.config.callback) {
        this.config.callback(vl)
      }
    },
    getList () {      
      var mid = ''
	    this.$bcstoreListByMcid(this.mcid, res => {        
        if (res.status == 200) {                 
          this.tableData = res.data
          if (res.data.length > 0 && !this.config.value) {            
            this.setDfVl(this.tableData[0].branchNo)
          }
        }
      }, '')
    }
  },
  mounted () {
    if (this.config) {
      this.slvl = this.config.value?this.config.value:''
      this.slsize = this.config.size?this.config.size:''
	  this.mcid = this.config.mcid?this.config.mcid: ''	 	  
    }
	
	// var _this = this
	// setTimeout(() => {		
		this.getList()
	// }, 100)	

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .bstore {
    width: 100%;
  }
</style>
